import { View } from './view';

export const Tabs = View;
